var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResourceDeletedIcon = function SvgResourceDeletedIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "145px",
    height: "148px",
    viewBox: "0 0 145 148",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.3687495,28.5039383 C107.778689,37.3348621 113.488603,52.2140488 111.752789,67.6681654 C110.039815,83.0992847 100.903952,99.0593397 88.8217725,102.41693 C76.7624332,105.774521 61.756778,96.529648 47.2992746,88.5956149 C32.8417711,80.6385846 18.8867402,74.0153918 15.3694329,63.5286698 C11.8521256,53.0649451 18.7497022,38.7606883 28.3651982,29.8837702 C37.9806942,21.006852 50.3141094,17.5572724 63.0357988,17.2123145 C75.7803279,16.8903537 88.9359708,19.6500174 98.3687495,28.5039383 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.358453,35.2320727 C124.766197,44.0368946 112.850523,53.7395283 111.115114,69.1479665 C109.402539,84.5334756 100.268808,100.446357 88.1894479,103.794023 C76.1329224,107.14169 61.1307685,97.9241421 46.6766386,90.01356 C32.2225086,82.0800486 18.2707338,75.4764323 14.7542472,65.0207063 C11.2377606,54.5879096 8.88267218,40.0511245 18.4959245,31.2004442 C28.1091768,22.3497639 31.0686063,-5.1536801 43.7873273,-5.49761845 C56.5288827,-5.81862758 105.927876,26.4043217 115.358453,35.2320727 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockups---Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subfolder---inside-view-Copy-6",
    transform: "translate(-90.000000, -191.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal-leave-page",
    transform: "translate(16.000000, 184.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(81.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 11.687500)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "mask",
    fill: "#DFF6FB",
    fillRule: "nonzero",
    transform: "translate(63.250000, 60.156250) scale(-1, 1) rotate(-26.000000) translate(-63.250000, -60.156250) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mask",
    fillRule: "nonzero",
    transform: "translate(65.312500, 49.500000) scale(-1, 1) rotate(-26.000000) translate(-65.312500, -49.500000) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0.687500, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14695947,45.375 C5.7560853,45.375 6.24987935,45.8687941 6.24987935,46.4779199 L6.24987935,46.4779199 L6.249,49.419 L9.19099905,49.4190396 C9.7595165,49.4190396 10.2275671,49.8491891 10.2874472,50.4017842 L10.2939189,50.5219595 C10.2939189,51.1310853 9.80012488,51.6248794 9.19099905,51.6248794 L9.19099905,51.6248794 L6.249,51.624 L6.24987935,54.5659991 C6.24987935,55.1345165 5.81972987,55.6025671 5.26713474,55.6624472 L5.14695947,55.6689189 C4.53783364,55.6689189 4.04403958,55.1751249 4.04403958,54.5659991 L4.04403958,54.5659991 L4.044,51.624 L1.10291989,51.6248794 C0.534402442,51.6248794 0.0663517927,51.1947299 0.00647178373,50.6421347 L1.54543045e-13,50.5219595 C1.54543045e-13,49.9128336 0.493794053,49.4190396 1.10291989,49.4190396 L1.10291989,49.4190396 L4.044,49.419 L4.04403958,46.4779199 C4.04403958,45.9094024 4.47418907,45.4413518 5.0267842,45.3814718 Z",
    id: "Combined-Shape-Copy",
    fill: "#FCC78C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#84CFEC",
    cx: 18.21875,
    cy: 27.15625,
    r: 1.71875
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8AD28F",
    cx: 116.53125,
    cy: 58.09375,
    r: 1.71875
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#CEA8EF",
    strokeWidth: 1.375,
    cx: 107.59375,
    cy: 28.53125,
    r: 2.40625
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(50.875000, 0.000000)",
    fill: "#ACC2D3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.21621622,0.808277027 L9.21621622,6.73564189 C9.21621622,7.18204097 9.57809417,7.54391892 10.0244932,7.54391892 C10.4708923,7.54391892 10.8327703,7.18204097 10.8327703,6.73564189 L10.8327703,0.808277027 C10.8327703,0.361877951 10.4708923,0 10.0244932,0 C9.57809417,0 9.21621622,0.361877951 9.21621622,0.808277027 Z",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75,1.88597973 L2.75,7.81334459 C2.75,8.25974367 3.11187795,8.62162162 3.55827703,8.62162162 C4.0046761,8.62162162 4.36655405,8.25974367 4.36655405,7.81334459 L4.36655405,1.88597973 C4.36655405,1.43958065 4.0046761,1.0777027 3.55827703,1.0777027 C3.11187795,1.0777027 2.75,1.43958065 2.75,1.88597973 Z",
    id: "Line",
    transform: "translate(3.558277, 4.849662) rotate(-45.000000) translate(-3.558277, -4.849662) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6824324,1.88597973 L15.6824324,7.81334459 C15.6824324,8.25974367 16.0443104,8.62162162 16.4907095,8.62162162 C16.9371085,8.62162162 17.2989865,8.25974367 17.2989865,7.81334459 L17.2989865,1.88597973 C17.2989865,1.43958065 16.9371085,1.0777027 16.4907095,1.0777027 C16.0443104,1.0777027 15.6824324,1.43958065 15.6824324,1.88597973 Z",
    id: "Line",
    transform: "translate(16.490709, 4.849662) scale(-1, 1) rotate(-45.000000) translate(-16.490709, -4.849662) "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "diskette-icon",
    transform: "translate(26.125000, 11.687500)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(7.854167, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.375,12.6875 L54.375,49.5959473 C54.375,52.2307983 52.2307983,54.375 49.5959473,54.375 L41.6308594,54.375 L12.7441406,54.375 L4.77905273,54.375 C2.14420166,54.375 0,52.2307983 0,49.5959473 L0,4.77905273 C0,2.14420166 2.14420166,0 4.77905273,0 L41.6875,0 C41.7873291,0.0615966797 54.375,12.7298687 54.375,12.6875 Z",
    id: "Path",
    fill: "#FEEFD4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.15625,
    y1: 20.2395833,
    x2: 46.21875,
    y2: 20.2395833,
    id: "Line-5",
    stroke: "#F6DEB3",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.15625,
    y1: 28.6979167,
    x2: 46.21875,
    y2: 28.6979167,
    id: "Line-5",
    stroke: "#F6DEB3",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.15625,
    y1: 36.5520833,
    x2: 46.21875,
    y2: 36.5520833,
    id: "Line-5",
    stroke: "#F6DEB3",
    strokeWidth: 1.8125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#F6DEB3",
    points: "41.6875 0 54.375 12.6875 41.6875 12.6875"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6875,50.0915527 L70.6875,74.6803866 C70.6875,75.7479002 70.3168223,76.7348747 69.6912822,77.5313415 C68.7728559,78.7007246 67.3050354,79.4594394 65.654371,79.4594394 L57.2658228,79.4594394 L13.4216772,79.4594394 L5.03312896,79.4594394 C2.25819719,79.4594394 0,77.3152377 0,74.6803866 L0,50.0915527 C0,47.4567017 2.25819719,45.3125 5.03312896,45.3125 L13.4216772,45.3125 L64.6276641,45.5217403 C64.7328006,45.583337 67.1074107,45.3174017 68.8039114,46.7327959 C70.5004121,48.14819 70.6875,50.0915527 70.6875,50.0915527 Z",
    id: "Path",
    fill: "#CFD5DA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2871094,68.2950699 L64.2871094,88.3369548 L7.49544271,88.3369548 L7.49544271,68.2950699 C7.49544271,67.3521904 8.21443423,66.5869548 9.90774459,66.5869548 L62.5275853,66.5869548 C64.2208956,66.5869548 64.2871094,67.3521904 64.2871094,68.2950699 Z",
    id: "Path",
    fill: "#657480",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8020833,71.3832729 C13.1484841,73.4857221 12.3216844,75.5119493 12.3216844,77.4619548 C12.3216844,79.4119602 13.1484841,81.431881 14.8020833,83.5217172 C16.3593343,85.3537211 17.1379598,86.9588003 17.1379598,88.3369548 C17.1379598,89.7151092 16.3593343,91.1730499 14.8020833,92.7107769 C12.5042606,94.8962989 12.5042606,97.2218733 14.8020833,99.6875",
    id: "Line-6",
    stroke: "#FEEFD4",
    strokeWidth: 6.04166667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5220656,71.3832729 C35.8684663,73.4857221 35.0416667,75.5119493 35.0416667,77.4619548 C35.0416667,79.4119602 35.8684663,81.431881 37.5220656,83.5217172 C39.0793165,85.3537211 39.857942,86.9588003 39.857942,88.3369548 C39.857942,89.7151092 39.0793165,91.1730499 37.5220656,92.7107769 C35.2242428,94.8962989 35.2242428,97.2218733 37.5220656,99.6875",
    id: "Line-6-Copy-2",
    stroke: "#FEEFD4",
    strokeWidth: 6.04166667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4387322,71.3832729 C23.785133,73.4857221 22.9583333,75.5119493 22.9583333,77.4619548 C22.9583333,79.4119602 23.785133,81.431881 25.4387322,83.5217172 C26.9959832,85.3537211 27.7746087,86.9588003 27.7746087,88.3369548 C27.7746087,89.7151092 26.9959832,91.1730499 25.4387322,92.7107769 C23.1409095,94.8962989 23.1409095,97.2218733 25.4387322,99.6875",
    id: "Line-6-Copy-5",
    stroke: "#FEEFD4",
    strokeWidth: 6.04166667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3970656,71.3832729 C46.7434663,73.4857221 45.9166667,75.5119493 45.9166667,77.4619548 C45.9166667,79.4119602 46.7434663,81.431881 48.3970656,83.5217172 C49.9543165,85.3537211 50.732942,86.9588003 50.732942,88.3369548 C50.732942,89.7151092 49.9543165,91.1730499 48.3970656,92.7107769 C46.0992428,94.8962989 46.0992428,97.2218733 48.3970656,99.6875",
    id: "Line-6-Copy-3",
    stroke: "#FEEFD4",
    strokeWidth: 6.04166667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2720656,71.3832729 C57.6184663,73.4857221 56.7916667,75.5119493 56.7916667,77.4619548 C56.7916667,79.4119602 57.6184663,81.431881 59.2720656,83.5217172 C60.8293165,85.3537211 61.607942,86.9588003 61.607942,88.3369548 C61.607942,89.7151092 60.8293165,91.1730499 59.2720656,92.7107769 C56.9742428,94.8962989 56.9742428,97.2218733 59.2720656,99.6875",
    id: "Line-6-Copy-4",
    stroke: "#FEEFD4",
    strokeWidth: 6.04166667,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#3EB646",
    cx: 64.34375,
    cy: 56.4895833,
    r: 2.11458333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#F9BA48",
    cx: 57.6979167,
    cy: 56.4895833,
    r: 2.11458333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2871094,68.2950699 L64.2871094,72.9224447 L7.49544271,72.9224447 L7.49544271,68.2950699 C7.49544271,67.3521904 8.21443423,66.5869548 9.90774459,66.5869548 L62.5275853,66.5869548 C64.2208956,66.5869548 64.2871094,67.3521904 64.2871094,68.2950699 Z",
    id: "Path",
    fill: "#8295A3",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E02020",
    cx: 99.6875,
    cy: 85.9375,
    r: 11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.6875,80.4375 C100.295013,80.4375 100.7875,80.9651644 100.7875,81.6160714 L100.7875,81.6160714 L100.7875,84.8375 L104.008929,84.8375 C104.616442,84.8375 105.116597,85.2665107 105.180584,85.8176429 L105.1875,85.9375 C105.1875,86.5450132 104.659836,87.0375 104.008929,87.0375 L104.008929,87.0375 L100.7875,87.0375 L100.7875,90.2589286 C100.7875,90.8664418 100.358489,91.366597 99.8073571,91.4305843 L99.6875,91.4375 C99.0799868,91.4375 98.5875,90.9098356 98.5875,90.2589286 L98.5875,90.2589286 L98.5875,87.0375 L95.3660714,87.0375 C94.7585582,87.0375 94.258403,86.6084893 94.1944157,86.0573571 L94.1875,85.9375 C94.1875,85.3299868 94.7151644,84.8375 95.3660714,84.8375 L95.3660714,84.8375 L98.5875,84.8375 L98.5875,81.6160714 C98.5875,81.0085582 99.0165107,80.508403 99.5676429,80.4444157 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(99.687500, 85.937500) rotate(45.000000) translate(-99.687500, -85.937500) "
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResourceDeletedIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resourceDeletedIcon.d72646f9.svg";
export { ForwardRef as ReactComponent };